import { isEqual } from 'lodash';
import * as React from 'react';

import { EProcessStatus, IAsyncData } from '../../models';

export interface IProps<T> {
    branch: IAsyncData<T>;
    /**
     * If some of dependencies change rerender will occur.
     * Needed when you reference some outter scope variables in render props.
     * For example, `successRender` uses `state.counter` value. If you won't specify.
     */
    deps: any[];
    successRender?: (data: T) => JSX.Element | null;
    errorRender?: () => JSX.Element | null;
    initialRender?: () => JSX.Element | null;
    loadingRender?: () => JSX.Element | null;
    elseRender?: (branch: IAsyncData<T>) => JSX.Element | null;
}

export class Async<T> extends React.Component<IProps<T>> {
    public static readonly renderNull = (): null => null;

    public shouldComponentUpdate (nextProps: IProps<T>): boolean {
        return nextProps.branch !== this.props.branch || !isEqual(this.props.deps, nextProps.deps);
    }

    public render (): JSX.Element {
        const {
            branch,
            successRender,
            errorRender,
            initialRender,
            loadingRender,
            elseRender,
        } = this.props;

        let result = null;

        if (successRender && branch.status === EProcessStatus.SUCCESS) {
            result = successRender(branch.data as any);
        } else if (errorRender && branch.status === EProcessStatus.ERROR) {
            result = errorRender();
        } else if (initialRender && branch.status === EProcessStatus.IDLE) {
            result = initialRender();
        } else if (loadingRender && branch.status === EProcessStatus.PENDING) {
            result = loadingRender();
        } else if (elseRender) {
            result = elseRender(branch);
        }

        return (<>{result}</>);
    }
}
